import React, { useContext } from 'react';
import CodePillLink from './CodePillLink'
import CodeX from './CodeX'
import CoderOverlay from './CoderOverlay';
import { useCode } from 'hooks/codes/queries';
import ProjectContext from 'contexts/ProjectContext';
import { useActiveCode } from 'contexts/ActiveCodeContext';

const CodeTag = (props) => {
  const [mouseIn, setMouseIn] = React.useState(false);

  // Use the useCode hook to fetch code data
  const { data: codeData } = useCode(props.id);

  const projectContext = useContext(ProjectContext);
  const { activeCodeId } = useActiveCode();
  
  // Get name from either the codeData or props as fallback
  if ( !codeData ) return null;
  const codeName = codeData?.name || props.name;
  const codeColor = activeCodeId && activeCodeId !== props.id ? 'grey' : codeData?.color;;
    
  
  const onMouseEnter = () => {
    setMouseIn(true);
    if (props.tagEnter)
      props.tagEnter(props.id);
  };

  const onMouseLeave = () => {
    setMouseIn(false);
    if (props.tagLeave)
      props.tagLeave(props.id);
  };

  const onRemove = (e) => {
    //IE9 & Other Browsers
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    //IE8 and Lower
    else {
      e.cancelBubble = true;
    }

    if (props.id)
      props.onCodeRemove(props.id);
  };

  return (
    <span
      style={{marginRight:12, padding:0, maxWidth:"100%"}}
      className="code-tag-container"
      data-code-id={props.id}
    >
      {' '}
      <CoderOverlay
        coders={props.coders}
        projectId={projectContext?.project?.id}
        // If this is in an excerpt, the codes should always be dark
        // If this is in a project, and this code is selected
        // We make the coders darker
        selected={props.selected && !props.inExcerpt}
      >
        <span
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          style={{cursor:"pointer", marginRight:2, padding:0, maxWidth:"100%"}}
          className="code-tag"
        >
          <CodePillLink
            server_id={props.server_id}
            codePage={props.codePage}
            projectID={props.projectID}
            name={codeName}
            codeColor={codeColor}
            selected={props.selected}
            id={props.id}
            onClick={props.onClick}
          />
        </span>
      </CoderOverlay>
      {props.selected && props.hasEditPermission &&
        <CodeX onClick={onRemove} codeColor={codeColor}/>
      }
    </span>
  );
};

export default CodeTag;